import React, { Fragment, useEffect, useState } from 'react';
import { default as CircularProgress } from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import RefreshIcon from '@material-ui/icons/Autorenew';
import TranslationHelper from '../../helpers/TranslationHelper';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    name?: string;
    valid?: boolean;
    download?: string;
    paramName: string;
    imageUrl: string;
    apiDownload: string;
}

const Image = ({
    name,
    valid,
    download,
    paramName,
    imageUrl,
    apiDownload,
}: IOwnProps) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const classes = useStyles();

    const handleError = () => {
        setLoading(false);
        setError(true);
    };
    useEffect(() => {
        resetData();
    }, [imageUrl]);

    const resetData = () => {
        setError(false);
        setLoading(true);
    };

    const handleOnLoad = () => {
        setLoading(false);
    };

    if (!valid) {
        return (
            <div className={classes.invalidImage} title={name}>
                {TranslationHelper.translate('No image')}
            </div>
        );
    }

    return (
        <Fragment>
            <div
                className={classes.invalidImage}
                title={name}
                style={{ display: loading ? 'flex' : 'none' }}
            >
                <CircularProgress />
            </div>
            <div
                className={classes.photoContainer}
                style={{ display: loading || error ? 'none' : 'block' }}
            >
                <a href={apiDownload} download={download}>
                    <img
                        key={Date.now() + paramName}
                        className={classes.validImage}
                        src={imageUrl}
                        title={name}
                        onLoad={handleOnLoad}
                        onError={handleError}
                    />
                </a>
            </div>
            <div
                className={classes.invalidImage}
                title={name}
                style={{ display: error ? 'flex' : 'none' }}
            >
                {TranslationHelper.translate('The image has not been found.')}
                <IconButton onClick={resetData}>
                    <RefreshIcon />
                </IconButton>
            </div>
        </Fragment>
    );
};

export default Image;
